export const DESIGN_SYSTEM_TRANSLATION_NAMESPACE = "design-system";
export const DESIGN_SYSTEM_COMMON_TK = "DESIGN_SYSTEM_COMMON_TK";
export const DESIGN_SYSTEM_DISPLAY_TK = "DESIGN_SYSTEM_DISPLAY_TK";
export const DESIGN_SYSTEM_INPUTS_TK = "DESIGN_SYSTEM_INPUTS_TK";
export const DESIGN_SYSTEM_TABLES_TK = "DESIGN_SYSTEM_TABLES_TK";
